module.exports = "<div class=cpt-ax-content-tab-inner ng-transclude> </div> ";